import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import StartAConversation from "./sections/StartAConversation";
import TheEduStreamEcosystem from "./sections/TheEduStreamEcosystem";
import TheFoundationFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <StartAConversation />
      <TheEduStreamEcosystem />
      <TheFoundationFooter />
    </div>;
}